import { useNavigate } from 'react-router'
import { useLocation } from 'react-router-dom'

import { Box, IconButton, Link, Typography, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useIam, useMappedTranslation } from 'hooks'
import i18n from 'utils/i18n'

import { AutomationTagIds } from '../../../assets/test/test-automation-tag-id'

export function HeaderWithSignup() {
  const t = useMappedTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()
  const isMobileView = useMediaQuery(theme.breakpoints.down('md'))

  const { language } = i18n

  const { handleSignUp } = useIam()

  let Logo = `/assets/images/header/logo.svg`

  switch (language) {
    case 'fr-FR':
      Logo = `/assets/images/header/logo-fr.svg`
      break

    case 'ja-JP':
      Logo = `/assets/images/header/logo-ja.svg`
      break

    case 'zh-HK':
      Logo = `/assets/images/header/logo-zh-HK.svg`
      break

    case 'zh-TW':
      Logo = `/assets/images/header/logo-zh-TW.svg`
      break

    case 'zh-CN':
      Logo = `/assets/images/header/logo-zh.svg`
      break

    default:
      Logo = `/assets/images/header/logo.svg`
      break
  }

  const handleLogoButton = () => {
    if (location.pathname !== '/dashboard/intro' && location.pathname !== '/adaptive-authentication/email') {
      navigate('/dashboard')
    }
  }

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.common.white
      }}
    >
      <Box
        sx={{
          height: {
            xs: '56px',
            md: '80px'
          },
          maxWidth: '1440px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: '24px',
          margin: '0 auto',
          padding: isMobileView ? '0px 24px' : '0px 88px'
        }}
      >
        {isMobileView ? (
          <IconButton sx={{ height: '24px', width: '24px' }} data-testid='IconButtonE76E326E'></IconButton>
        ) : (
          <IconButton
            disableRipple
            sx={{ height: '100%', padding: 0, outlineOffset: '-2px' }}
            onClick={handleLogoButton}
            data-testid='IconButtonEF1C2283'
          >
            <Box
              component='img'
              alt=''
              src={Logo}
              minWidth='152px'
              sx={{
                display: 'block',
                height: {
                  xs: '14px',
                  md: '24px'
                },
                filter: theme.palette.mode === 'dark' ? 'invert(1)' : null
              }}
            />
          </IconButton>
        )}
        <Link
          component='button'
          type='button'
          underline='none'
          sx={{ padding: '7px 0px 6px', display: 'flex', alignItems: 'center' }}
          onClick={() => handleSignUp()}
          data-testid='Box0B099647'
        >
          <Typography
            sx={{
              fontSize: isMobileView ? '12px' : '14px',
              lineHeight: '1.33',
              fontWeight: '700',
              color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black
            }}
            data-testid={AutomationTagIds['dashboard.header.signup']}
          >
            {t('iam.01.Common.Button.CREATE.ACCOUNT')}
          </Typography>
        </Link>
      </Box>
    </Box>
  )
}
